import { CookiePolicyBannerFields, CookiePolicyBannerProps } from "./fields.definitions";

export class CookiePolicyBannerModel {
  private readonly fields: null | CookiePolicyBannerFields;
  constructor(props: CookiePolicyBannerProps) {
    this.fields = props.fields || null;
  }

  get CBID(): string {
    return this.fields?.Cbid?.value ?? "e7640f21-0411-4f59-976d-fc5996d9747c";
  }

  get culture(): string {
    return this.fields?.Culture?.value ?? "EN";
  }

  get src(): string {
    return this.fields?.Src?.value ?? "";
  }
}
